import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ModalProvider } from './services/ModalService';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Solutions from './pages/Solutions';
import Staffing from './pages/Staffing';
import About from './pages/About';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminApplications from './pages/AdminApplications';

import BookkeepingAccounting from './pages/BookkeepingAccounting';
import TaxPreparation from './pages/TaxPreparation';
import PayrollManagement from './pages/PayrollManagement';
import EquityManagement from './pages/EquityManagement';
import FundAdministration from './pages/FundAdministration';

import './App.css';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import AIMachineLearning from './pages/AIMachineLearning';
import CloudSolutions from './pages/CloudSolutions';
import DevOpsSRE from './pages/DevOpsSRE';
import DataAnalytics from './pages/DataAnalytics';
import Footer from './components/Footer';

function App() {
  return (
    <ModalProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bookkeeping-accounting" element={<BookkeepingAccounting />} />
            <Route path="/tax-preparation" element={<TaxPreparation />} />
            <Route path="/payroll-management" element={<PayrollManagement />} />
            <Route path="/equity-management" element={<EquityManagement />} />
            <Route path="/fund-administration" element={<FundAdministration />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/staffing" element={<Staffing />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/solutions/software-development" element={<SoftwareDevelopment />} />
            <Route path="/solutions/ai-machine-learning" element={<AIMachineLearning />} />
            <Route path="/solutions/cloud-solutions" element={<CloudSolutions />} />
            <Route path="/solutions/devops-sre" element={<DevOpsSRE />} />
            <Route path="/solutions/data-analytics" element={<DataAnalytics />} />
            <Route path="/admin/view-applications" element={<AdminApplications />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ModalProvider>
  );
}

export default App;
